module.exports = __webpack_public_path__ + "static/media/A4.19f3b781.png";